import React from 'react';
import { Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { mapStateToProps } from 'root/redux/selector/selector';
import { withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PropTypes from 'prop-types';
import Loading from 'root/components/Loading/Loading';
import MessagePopUp from 'root/components/MessagePopUp';
import { on } from 'i18next';
import SVGElements from 'root/components/SVGElements';
import { Fragment } from 'react';

class GameList extends React.Component {
    isMount = true;
    constructor(props) {
        super(props);
        this.state = {
            detailModal: false,
            loginModal: false,
            msgTitle: '',
            currentDomainPath: '',
        };
        this.toggleDetailModal = this.toggleDetailModal.bind(this);
    }

    toggleDetailModal = () => {
        this.setState({ detailModal: !this.state.detailModal, loginModal: false });
    };

    componentDidMount() {
        this.isMount = true;
        this.setState({ currentDomainPath: this.props.history.location.pathname });
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    launchGame = (gameObj, isFun) => {
        const { language, screen } = this.props;

        if (gameObj) {
            gameObj.category = 'SL';
        }

        let params = {
            domain: window.location.hostname,
            isMobile: screen.isMobile,
            isFun: isFun,
            isMenuMode: !isFun,
            isMiniGame: false,
            languageKey: language.key,
        };

        if (this.props.slotsFunction.provider === 'UL') {
            params.gameCode = 'S-UL01';
            params.provider = 'UL';
        } else {
            params.gameCode = gameObj.game;
            params.provider = gameObj.provider;
        }

        window.SPL_Provider.getIsEnabledWithouthAuth(gameObj, screen.viewType, params).then((isEnabled) => {
            const { isLogin } = this.props.user;
            if (!isLogin && !isEnabled) {
                if (this.isMount) {
                    if (this.props.screen.isMobile) {
                        this.props.history.push({ pathname: '/login', state: { currentDomainPath: this.state.currentDomainPath } });
                    } else {
                        this.setState({ detailModal: true, loginModal: true }, () => {
                            this.loginMsg();
                        });
                    }
                }
            } else {
                window.SPL_Provider.generateGameUrl(gameObj, language, screen.viewType, params).then((url) => {
                    window.open(url, '_blank');
                    // setTimeout(() => {
                    //   window.location.reload(true);
                    // }, 2000);
                });
            }
        });
    };

    loginMsg = () => {
        if (this.state.loginModal) {
            this.setState({ msgTitle: 'login:login.proceed' });
        }
    };

    handleLoginModalOk = () => {
        if (this.isMount) {
            this.setState({ loginModalVisible: false });
        }
    };

    getThumbnailPath = (obj) => {
        const { slotThumbnail } = this.props.portal.settings;
        let path = obj.thumbnail;

        if (slotThumbnail) {
            if (path) {
                path = '/public/html/games/images/' + slotThumbnail + '/' + obj.provider + '/' + obj.game + '.jpg';
            }
        }

        return path;
    };

    render() {
        const { slotGamesList, provider, isLoading, onItemClick, updateMemberFavoriteGame } = this.props.slotsFunction;

        const { detailModal, loginModal, msgTitle } = this.state;

        let modalMsg = {
            detailModal: detailModal,
            loginModal: loginModal,
            msgTitle: msgTitle,
            toggleDetailModal: this.toggleDetailModal,
        };
        return (
            <Translation>
                {(t) => (
                    <div className='nav-game-box'>
                        {this.state.detailModal && <MessagePopUp modalMsg={modalMsg} />}

                        {this.props.selectedGameObj && (
                            <Fragment>
                                <div
                                    className='hover-box-mask'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                ></div>
                                <div
                                    className='hover-box'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                >
                                    <div className='game-item-info'>
                                        <p>{this.props.selectedGameObj.name}</p>
                                    </div>
                                    <div className='img-box'>
                                        <LazyLoadImage src={this.getThumbnailPath(this.props.selectedGameObj)} alt='slot-game-hover-img' />
                                        <div className='item-menu'>
                                            <span
                                                onClick={() => {
                                                    this.launchGame(this.props.selectedGameObj, false);
                                                }}
                                                className='btn-normal'
                                            >
                                                {t('slot:slot.play', 'PLAY')}
                                            </span>
                                            {this.props.selectedGameObj.playForFun && (
                                                <span
                                                    onClick={() => {
                                                        this.launchGame(this.props.selectedGameObj, true);
                                                    }}
                                                    className='btn-normal-green'
                                                >
                                                    {t('slot:slot.demo', 'DEMO')}
                                                </span>
                                            )}
                                            <div>
                                                <SVGElements
                                                    className='icon-love-on'
                                                    name={this.props.selectedGameObj.isFavourite ? 'love-icon-on' : 'love-icon'}
                                                    onClick={() => updateMemberFavoriteGame(this.props.selectedGameObj)}
                                                />
                                                <span>{t('home:home.addFavourite', 'Add To Favourite')}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <SVGElements className='icon-close' name='close-icon' onClick={() => onItemClick(null, null)} />
                                </div>
                            </Fragment>
                        )}

                        {!isLoading && !['UL', 'SRC', 'MEGA'].some((name) => provider.includes(name)) && (
                            <ul className='nav-game'>
                                <TransitionGroup className='items'>
                                    {slotGamesList?.length > 0 &&
                                        slotGamesList.map((info, i) => (
                                            <CSSTransition key={i} timeout={300} classNames='item'>
                                                <li
                                                    className={[info.on ? 'on' : ''].join(' ')}
                                                    onClick={(e) => {
                                                        onItemClick(info, i);
                                                    }}
                                                >
                                                    {info.customImage ? (
                                                        <LazyLoadImage src={info.thumbnail} alt='slot-game-img' />
                                                    ) : (
                                                        <LazyLoadImage src={this.getThumbnailPath(info)} alt='slot-game-img' />
                                                    )}
                                                    <p>
                                                        <SVGElements
                                                            className='icon-love-on'
                                                            name={info.isFavourite ? 'love-icon-on' : 'love-icon'}
                                                            onClick={() => updateMemberFavoriteGame(info)}
                                                        />
                                                        {/* <i className={`${info.isFavourite ? 'icon-love-on' : 'icon-love'}`} onClick={() => updateMemberFavoriteGame(info)}></i> */}
                                                        <span className='gamename'>{info.name}</span>
                                                    </p>

                                                    {!slotGamesList.underMaintenance && !this.props.screen.isMobile && (
                                                        <Fragment>
                                                            <div
                                                                className='hover-box-mask'
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                            ></div>
                                                            <div
                                                                className='hover-box'
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                            >
                                                                <div className='game-item-info'>
                                                                    <p>{info.name}</p>
                                                                </div>
                                                                <div className='img-box'>
                                                                    {info.customImage ? (
                                                                        <LazyLoadImage src={info.thumbnail} alt='slot-game-img' />
                                                                    ) : (
                                                                        <LazyLoadImage src={this.getThumbnailPath(info)} alt='slot-game-img' />
                                                                    )}
                                                                    <div className='item-menu'>
                                                                        <span
                                                                            onClick={() => {
                                                                                this.launchGame(info, false);
                                                                            }}
                                                                            className='btn-normal'
                                                                        >
                                                                            {t('slot:slot.play', 'PLAY')}
                                                                        </span>
                                                                        {info.playForFun && (
                                                                            <span
                                                                                onClick={() => {
                                                                                    this.launchGame(info, true);
                                                                                }}
                                                                                className='btn-normal-green'
                                                                            >
                                                                                {t('slot:slot.demo', 'DEMO')}
                                                                            </span>
                                                                        )}
                                                                        <div>
                                                                            <SVGElements
                                                                                className='icon-love-on'
                                                                                name={info.isFavourite ? 'love-icon-on' : 'love-icon'}
                                                                                onClick={() => updateMemberFavoriteGame(info)}
                                                                            />
                                                                            {/* <i className={`${info.isFavourite ? 'icon-love-on' : 'icon-love'}`} onClick={() => updateMemberFavoriteGame(info)}></i> */}
                                                                            <span>{t('home:home.addFavourite', 'Add To Favourite')}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <SVGElements className='icon-close' name='close-icon' onClick={() => onItemClick(null, null)} />
                                                            </div>
                                                        </Fragment>
                                                    )}
                                                </li>
                                            </CSSTransition>
                                        ))}
                                </TransitionGroup>
                            </ul>
                        )}
                        {isLoading && <Loading />}
                    </div>
                )}
            </Translation>
        );
    }
}

GameList.propTypes = { slotsFunction: PropTypes.object.isRequired };

export default connect(mapStateToProps)(withTranslation()(withRouter(GameList)));
